const PlayerApi = (xingPlayer, getUserAutoplaySettings) => ({
  play: (state = true, respectingAutoplaySettings = true) => {
    let respectingAutoplay =
      respectingAutoplaySettings === null ? true : respectingAutoplaySettings;
    if (respectingAutoplay && !getUserAutoplaySettings()) {
      // eslint-disable-next-line no-console
      console.warn(
        'XING Video API: Play was blocked because the user does not allow autoplay'
      );
      return;
    }
    state
      ? xingPlayer.videojs.play()
      : !xingPlayer.videojs.isInPictureInPicture() &&
        xingPlayer.videojs.pause();
  },

  pause: (state = true) => {
    state
      ? !xingPlayer.videojs.isInPictureInPicture() && xingPlayer.videojs.pause()
      : xingPlayer.videojs.play();
  },

  setVolume: (volume) => {
    if (volume > 0) {
      xingPlayer.videojs.muted(false);
    }
    xingPlayer.videojs.volume(volume / 100);
  },

  setMute: (state = !xingPlayer.videojs.muted()) => {
    xingPlayer.videojs.muted(state);
  },
});

export default PlayerApi;
